module.exports = __webpack_public_path__ + "img/logo-dim.994c0f1a.png";